// extracted by mini-css-extract-plugin
export default {"RulesetActionMenuLinkItem":"RulesetActionMenu-module__RulesetActionMenuLinkItem--KIlfs"};